<template>
    <web-layout :racingstars="$page.props.racingstars" :user="$page.props.user">
        <carousel ref="carousel" class="" :per-page="1" :adjustableHeight="true" :navigationEnabled="true" snapAlign='start' :mouseDrag="false" :touchDrag="false" style="text-align:left; height: 100%;">
            <slide  v-for="index in 5" :key="index" data-index="0" class="md:h-screen mx-auto" v-model="signupCarousel" style="justify-content: center; width: 100%;" :class="[currentSlideIndex === 1 ? '' : 'h-screen']">
                <img class="absolute top-0 left-0 w-full h-full object-cover z-0 lg:ml-auto lg:w-full" :src="asset('images/racingleague/RL_backdrop.svg')" alt="Purchasing tokens"/>
                <div class="flex flex-col md:flex-row max-w-7xl mx-auto lg:mx-0 w-screen" id="top">
                    <div v-if="index === 1 || accountCreated" class="text-center hidden md:flex flex-col h-full w-screen md:mx-2 lg:justify-end md:ml-36 md:mt-8" style="position: relative;">

                        <div class="mt-4 md:mt-16 sm:mt-24 lg:mt-0 lg:col-span-full lg:flex lg:flex-col lg:items-center w-full">
                            <div class="flex flex-col text-white w-full">
                                <span class="text-center font-extrabold mt-4 text-xl">WIN... </span>
                            </div>
                            <span class="flex justify-start text-white mt-4 w-full ml-4 bg-gradient-to-r from-racing-league-red to-transparent p-3 rounded-l-md">
                                <img class="col-start-2 mr-2 h-12 w-12 text-white fill-current" :src="asset('images/coreui/cil-drink.svg')"/>
                                <span class="my-auto font-semibold text-lg">Free drinks</span>
                            </span>
                            <span class="flex justify-end text-white mt-4 w-full -ml-4 bg-gradient-to-l from-racing-league-red to-transparent p-3 rounded-r-md">
                                <span class="my-auto mr-2 font-semibold text-lg">Premium viewing</span>
                                <img class="col-start-2 h-12 w-12 text-white fill-current" :src="asset('images/coreui/cil-gem.svg')"/>
                            </span>
                            <span class="flex justify-start text-white mt-4 w-full ml-4 bg-gradient-to-r from-racing-league-red to-transparent p-3 rounded-l-md">
                                <img class="col-start-2 mr-2 h-12 w-12 text-white fill-current" :src="asset('images/coreui/cil-gift.svg')"/>
                                <span class="my-auto font-semibold text-lg">Team merch</span>
                            </span>
                            <span class="flex justify-end text-white mt-4 w-full -ml-4 bg-gradient-to-l from-racing-league-red to-transparent p-3 rounded-r-md">
                                <span class="my-auto mr-2 font-semibold text-lg">RL team hub pass</span>
                                <img class="col-start-2 h-12 w-12 text-white fill-current" :src="asset('images/coreui/cil-door.svg')"/>
                            </span>
                            <span class="flex justify-start text-white my-4 w-full ml-4 bg-gradient-to-r from-racing-league-red to-transparent p-3 rounded-l-md">
                                <img class="col-start-2 mr-2 h-12 w-12 text-white fill-current" :src="asset('images/coreui/handshake.svg')"/>
                                <span class="my-auto font-semibold text-lg">Meet a member</span>
                            </span>
                        </div>
                    </div>
                    <div class="order-first flex flex-col justify-between md:mt-8 h-full mx-2 lg:justify-start" style="position: relative;">
                        <span class="mt-8 md:mt-16 sm:mt-24 lg:mt-0 lg:col-span-8 lg:flex lg:items-center h-full inline-flex flex-col" v-if="!accountCreated">

                            <button v-if="index>1 && index<4" @click="prevSlide()" class="btn py-1 mt-2 text-white border-white/25 bg-grey-400 font-normal w-16 mb-2 mr-auto">Back</button>

                            <form @submit.prevent="true" class="h-full">
                                <input type="hidden" name="_token" value="{{ csrf_token() }}" />
                                <span class="flex flex-col lg:justify-center mt-4 text-3xl tracking-tight font-extrabold text-white sm:leading-none lg:text-5xl xl:text-5xl mb-4 h-full">
                                    <div class="text-center mt-6 lg:mt-0" v-if="index===1">
                                        <p class="text-base pb-1">Next race starts in...</p>
                                        <Countdown :showSeconds="true" labelColor="#FFFFFF" :deadline="formatDeadline" countdownSize="2.19rem" mainColor="#FF4933" class="mb-3" style="margin-bottom: 20px;"/>
                                    </div>

                                    <span class="md:block text-4xl">FREE TO PLAY</span>
                                    <span class="md:block text-4xl block">
                                        <p class="" :class="[selectedTeam ? selectedTeam.foreground : 'text-racing-league-red']">WIN PRIZES</p>
                                        <p class="bg-racing-league-red text-white italic whitespace-nowrap text-4xl p-1" :class="[selectedTeam ? selectedTeam.background : '']">TAKE ON THE PROS</p>
                                    </span>

                                    <!-- First Slide -->
                                    <span v-if="index === 1" class="flex flex-col my-auto md:my-0 mt-10">
                                        <input id="email" type="email" v-model="form.email" @blur="emailGiven=true, checkEmailsAvailable(form.email)" autocomplete="email" placeholder="Enter your email" class="input input-bordered rounded-md mt-4 backdrop-blur bg-gray-800/50 text-white w-full" />
                                        <input type="email" v-model="confirmEmail" autocomplete="email" placeholder="Confirm email" class="input rounded-md mt-4 backdrop-blur bg-gray-800/50 text-white w-full" />

                                        <span v-if="!isEmailValid || !doEmailsMatch || !emailAvailable"  class="inline-flex pb-2 my-2" v-show="emailGiven">
                                            <svg class="w-6 h-6 my-auto mr-1 text-red-400" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                            <p v-if="!isEmailValid" class="text-red-400 text-sm my-auto">Your provided email is invalid.</p>
                                            <p v-else-if="!doEmailsMatch" class="text-red-400 text-sm my-auto">Your provided emails do not match.</p>
                                            <p v-else-if="!emailAvailable" class="text-red-400 text-sm my-auto">This email is already in use.</p>
                                        </span>

                                        <button @click="( slideOneComplete ? nextSlide() : '')" :disabled="!emailAvailable" class="btn bg-racing-league-red/50 backdrop-blur w-full mx-auto self-baseline mt-8" :class="[slideOneComplete ? 'opacity-100' : 'opacity-50', [selectedTeam.background]]">Sign up now!</button>
                                    </span>
                                    <button v-if="index === 1" @click="goToFormat()" class="btn flex bg-gray-800/20 w-full mx-auto self-baseline mt-4 justify-self-end lg:justify-self-start mb-20">
                                        <span class="flex flex-row justify-center w-full">
                                            <p>Learn more</p>
                                            <ExternalLinkIcon class="w-5 mb-1 ml-1"/>
                                        </span>
                                    </button>

                                    <!-- Second Slide -->
                                    <span v-if="index === 2" class="flex flex-col">
                                        <input type="password" v-model="form.password" @blur="passwordGiven=true" placeholder="Enter your password" class="input rounded-md mt-4 backdrop-blur bg-gray-800/50 text-white w-full" />
                                        <input type="password" v-model="confirmPassword" placeholder="Confirm password" class="input rounded-md mt-4 backdrop-blur bg-gray-800/50 text-white w-full" />

                                        <span v-if="!passwordGiven || !doPasswordsMatch || (form.password.length) < 8" class="inline-flex pb-2 my-2">
                                            <svg v-if="!doPasswordsMatch || !(form.password.length) < 8" class="w-6 h-6 my-auto mr-1 text-red-400" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                            <p v-if="!doPasswordsMatch" class="text-red-400 text-sm my-auto">Your passwords do not match.</p>
                                            <p v-else-if="(form.password.length) < 8" class="text-red-400 text-sm my-auto">Password must be atleast 8 characters long.</p>
                                        </span>
                                    </span>

                                    <button v-if="index === 2" :disabled="!doPasswordsMatch || (form.password.length) < 8" @keyup.enter="nextSlide()" @click="nextSlide()" class="btn bg-racing-league-red/50 backdrop-blur w-full mx-auto self-baseline mt-8" :class="[slideOneComplete ? 'opacity-100' : 'opacity-50', [selectedTeam.background]]">Choose your username</button>

                                    <!-- Third Slide -->
                                    <span v-if="index === 3" class="flex flex-col">
                                        <input type="text" v-model="form.username" @blur="checkUsernamesAvailable(form.username)" placeholder="Enter a Username" class="input rounded-md mt-4 backdrop-blur bg-gray-800/50 text-white w-full" />

                                        <span v-if="!usernameAvailable" class="inline-flex pb-2 my-2">
                                            <svg class="w-6 h-6 my-auto mr-1 text-red-400" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                            <p  class="text-red-400 text-sm my-auto">Sorry that username is unavailable.</p>
                                        </span>
                                    </span>

                                    <button v-if="index === 3" :disabled="(!usernameAvailable || !form.username)" @keyup.enter="nextSlide()" @click="nextSlide()" class="btn bg-racing-league-red/50 backdrop-blur w-full mx-auto self-baseline mt-8 opacity-100 disabled:opacity-50" :class="[selectedTeam ? selectedTeam.background : '']">Choose your Region</button>

                                    <!-- Fourth Slide -->
                                    <span v-if="index === 4" class="flex flex-col">

                                        <!-- Teams dropdown -->
                                        <div>
                                            <button id="dropdownteamsButton" @click="toggleDropdown" class="text-white font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center w-full mt-14 backdrop-blur" :class="[selectedTeam ? selectedTeam.background : 'btn']" type="button">
                                                <span class="inline-flex w-full justify-between">

                                                    <p v-if="!selectedTeam"> Choose your team </p>

                                                    <a v-else class="flex items-center text-base p-0 hover:text-white">
                                                        <img class="w-6 h-6 mr-2" :src="selectedTeam.icon" :alt="selectedTeam.name + ' image'">
                                                        {{ selectedTeam.name }}
                                                    </a>

                                                    <svg class="w-5 h-5 ml-2 my-auto" aria-hidden="true" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                                    </svg>
                                                </span>
                                            </button>

                                            <!-- Dropdown menu -->
                                            <div :class="{'hidden': !isDropdownOpen}" id="dropdownteams" class="absolute z-10 rounded-lg shadow w-full bg-gray-900">
                                                <ul @click="toggleDropdown" class="h-48 overflow-y-auto text-gray-700 dark:text-gray-200 rounded-md" aria-labelledby="dropdownteamsButton">
                                                    <li @click="selectedTeam=team" v-for="team in teams" :key="team.id">
                                                    <a href="#" class="flex items-center text-base px-4 py-2 hover:opacity-90 hover:text-white" :class="[team.background]">
                                                        <img class="w-6 h-6 mr-2" :src="team.icon" :alt="team.name + ' image'">
                                                        {{ team.name }}
                                                    </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </span>

                                    <div v-if="index === 4" class="mt-4">
                                        <jet-label for="terms">
                                            <div class="flex items-center">
                                                <input type="checkbox" id="terms" :value="value" v-model="form.terms" :class="[selectedTeam.background]" class="rounded opacity-70 backdrop-blur border-gray-300 text-gray-600 shadow-sm focus:border-gray-300 focus:ring focus:ring-gray-200 focus:ring-opacity-50 transition duration-500 ease-in-out" >
                                                <div class="ml-2 font-semibold text-gray-200 w-fit max-w-md">
                                                    I agree to the <a target="_blank" href="https://racingleague.racingstars.co.uk/terms" class="underline text-sm text-gray-600 hover:text-gray-900">Terms of Service</a> and <a target="_blank" href="https://racingleague.racingstars.co.uk/privacy" class="underline text-sm text-gray-600 hover:text-gray-900">Privacy Policy</a> and that I am a resident of the United Kingdom.
                                                </div>
                                            </div>
                                        </jet-label>
                                        <jet-label for="gdpr_email" class="mt-3">
                                            <div class="flex items-center">
                                                <input type="checkbox" id="gdpr_email" :value="value" v-model="form.gdpr_email" :class="[selectedTeam.background]" class="rounded opacity-70 backdrop-blur border-gray-300 text-gray-600 shadow-sm focus:border-gray-300 focus:ring focus:ring-gray-200 focus:ring-opacity-50 transition duration-500 ease-in-out" >
                                                <div class="ml-2 font-semibold text-gray-200 w-fit max-w-md">
                                                    I agree to receive the occasional marketing updates about promotions from Racing Stars & our partners <a target="_blank" href="https://racingleague.racingstars.co.uk/privacy" class="underline text-sm text-gray-600 hover:text-gray-900">Learn More</a>
                                                </div>
                                            </div>
                                        </jet-label>
                                    </div>

                                    <button v-if="index === 4" :disabled="!selectedTeam.background || !form.terms" @keyup.enter="nextSlide()" @click="nextSlide(), submit(), accountCreated=true" class="btn backdrop-blur w-full mx-auto self-baseline mt-8" :class="[selectedTeam.background]">
                                        Complete Sign Up
                                    </button>

                                    <!-- Fifth Slide -->
                                    <!-- <span v-if="index === 5" class="flex flex-col">

                                        <svg class="mx-auto w-36 h-36 mt-8 text-racing-league-red" :class="[selectedTeam ? selectedTeam.foreground : '']" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>
                                        </svg>

                                        <h class="text-center text-racing-league-red" :class="[selectedTeam ? selectedTeam.foreground : '']">Your almost there!</h>
                                        <p class="mt-4 text-center text-2xl">We just sent you an email.</p>
                                        <p class="text-center text-2xl">Please check your inbox and verify your account.</p>
                                        <p class="text-base opacity-50 text-center">( Dont forget to check your spam folder. )</p>
                                    </span> -->
                                </span>
                            </form>
                        </span>

                        <span class="mt-12 md:mt-16 sm:mt-24 lg:mt-0 lg:col-span-8 lg:flex lg:items-center h-full inline-flex flex-col" v-else>
                                <span class="md:block text-4xl block">
                                    <p class="md:block text-4xl text-white font-extrabold">SIT TIGHT</p>
                                    <p class="font-extrabold" :class="[selectedTeam ? selectedTeam.foreground : 'text-racing-league-red']">SADDLE UP</p>
                                    <p class="font-extrabold bg-racing-league-red text-white italic whitespace-nowrap text-3xl p-1 mr-auto" :class="[selectedTeam ? selectedTeam.background : '']">WATCH THIS SPACE</p>
                                </span>

                            <div class="text-center mt-6 lg:mt-0" v-if="index===1 || accountCreated">
                                <p class="text-2xl font-bold text-white pb-1 pt-4">Next race starts in...</p>
                                <Countdown :showSeconds="true" labelColor="#FFFFFF" :deadline="formatDeadline" countdownSize="2.19rem" mainColor="#FF4933" class="mb-3" style="margin-bottom: 20px;"/>
                            </div>

                            <span class="tracking-tight font-extrabold text-white">
                                Click here to learn more about Racing League and how it works
                                <button  @click="goToRacingLeague" class="btn flex bg-gray-800/20 w-full mx-auto self-baseline mt-4 justify-self-end lg:justify-self-start">
                                       <span class="flex flex-row justify-center w-full">
                                           <img class="h-12 w-auto sm:h-18" :src="asset('images/racingleague/racingleaguebase.png')" />
                                            <ExternalLinkIcon class="w-7 mb-1 ml-4 opacity-70"/>
                                        </span>
                                    </button>
                                    <br>
                                    Or, for a chance for some cash prizes head on over to Racing Stars with an extra 250 tokens<br>
                                <button  @click="goToRacingStars" class="btn flex bg-gray-800/20 w-full mx-auto self-baseline mt-4 justify-self-end lg:justify-self-start">
                                       <span class="flex flex-row justify-center w-full">
                                           <application-logo class="h-10 w-auto sm:h-8 m-2" />
                                            <ExternalLinkIcon class="w-7 mb-1 ml-4 opacity-70"/>
                                        </span>
                                </button>
                            </span>
                        </span>
                    </div>

                    <div v-if="currentSlideIndex === 1 || accountCreated" class="text-center flex flex-col md:hidden h-full w-screen md:mx-2 lg:justify-end md:ml-36 mt-10" style="position: relative;">
                        <p class="text-center w-full text-white font-bold">YOUR CHANCE TO WIN</p>

                        <div class="flex flex-row justify-evenly w-full pb-4">
                            <span class="flex flex-col text-white p-2 rounded-l-md">
                                <img class="col-start-2 h-12 w-12 text-white fill-current mx-auto" :src="asset('images/coreui/cil-drink.svg')"/>
                                <span class="font-semibold text-xs">Free<br>drinks</span>
                            </span>
                            <span class="flex flex-col text-white p-2 rounded-l-md">
                                <img class="col-start-2 h-12 w-12 text-white fill-current mx-auto" :src="asset('images/coreui/cil-gem.svg')"/>
                                <span class="font-semibold text-xs">Premium<br>viewing</span>
                            </span>
                            <span class="flex flex-col text-white p-2 rounded-l-md">
                                <img class="col-start-2 h-12 w-12 text-white fill-current mx-auto" :src="asset('images/coreui/cil-gift.svg')"/>
                                <span class="font-semibold text-xs">Team<br>merch</span>
                            </span>
                            <span class="flex flex-col text-white p-2 rounded-l-md">
                                <img class="col-start-2 h-12 w-12 text-white fill-current mx-auto" :src="asset('images/coreui/cil-door.svg')"/>
                                <span class="font-semibold text-xs">RL team<br>hub pass</span>
                            </span>
                            <span class="flex flex-col text-white p-2 rounded-l-md">
                                <img class="col-start-2 h-12 w-12 text-white fill-current mx-auto" :src="asset('images/coreui/handshake.svg')"/>
                                <span class="font-semibold text-xs">Meet a<br>Member</span>
                            </span>
                        </div>
                    </div>
                </div>
            </slide>
        </carousel>
    </web-layout>
</template>
<script>
import { ref, computed } from 'vue'
import { ExternalLinkIcon } from '@heroicons/vue/outline'
import { Head, Link, usePage } from '@inertiajs/inertia-vue3';
import WebLayout from '@/Layouts/WebLayout.vue'
import { useForm } from '@inertiajs/inertia-vue3'
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import moment from "moment";
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import ApplicationLogo from "@/Jetstream/ApplicationLogo.vue";
import VueCountdown from '@chenfengyuan/vue-countdown';
import {Countdown} from 'vue3-flip-countdown';
import { onMounted } from 'vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetLabel from '@/Jetstream/Label.vue'

export default {

    props: {
        nextRaceStartTime: String,
        totalWinners: Number,
        totalJackpot: Number,
        accountCreated: Boolean,
    },

    data() {
        return {
            confirmEmail : "",
            confirmPassword : "",
            isDropdownOpen: false,
            currentSlideIndex: 1,
            slideIndexRef: null,
            signupCarousel: 0,

            teams: [
                { id: 1, name: 'Wales & The West', icon: 'images/racingleague/rl-wales.svg', value:"wales", background:"bg-rl-wales/70" ,foreground:"text-rl-wales/80" },
                { id: 2, name: 'London & The South', icon: 'images/racingleague/rl-london.svg', value:"london", background:"bg-rl-london/70" ,foreground:"text-rl-london/80"},
                { id: 3, name: 'Scotland', icon: 'images/racingleague/rl-scotland.svg', value:"scotland", background:"bg-rl-scotland/70" ,foreground:"text-rl-scotland/80"},
                { id: 4, name: 'The East', icon: 'images/racingleague/rl-east.svg', value:"east", background:"bg-rl-east/70" ,foreground:"text-rl-east/80"},
                { id: 5, name: 'Yorkshire', icon: 'images/racingleague/rl-yorkshire.svg', value:"yorkshire", background:"bg-rl-yorkshire/70" ,foreground:"text-rl-yorkshire/80"},
                { id: 6, name: 'The North', icon: 'images/racingleague/rl-north.svg', value:"north", background:"bg-[#1b2335] bg-opacity-70" ,foreground:"text-[#2b3b61]"},
                { id: 7, name: 'Ireland', icon: 'images/racingleague/rl-ireland.svg', value:"ireland", background:"bg-rl-ireland/70" ,foreground:"text-rl-ireland/80"},
            ],

            form: this.$inertia.form({
                first_name: '',
                last_name: '',
                day: '',
                month: '',
                year: '',
                date_of_birth: '',
                email: '',
                mobile: '',
                building: '',
                street: '',
                city: '',
                postcode: '',
                country_id: 169,
                username: '',
                password: '',
                gdpr_email: false,
                password_confirmation: '',
                terms: false,
                avatar: '',
            }),
        }
    },

    mounted() {
        this.slideIndexRef = this.$refs.slideIndex;
    },

    components: {
        ApplicationLogo,
        Carousel,
        Slide,
        Link,
        WebLayout,
        Pagination,
        Navigation,
        ExternalLinkIcon,
        faExternalLink,
        VueCountdown,
        Countdown,
        JetCheckbox,
        JetLabel
    },

    methods: {

        goToRacingLeague() {
            window.location.href = "https://www.racingleague.uk";
        },

        goToRacingStars() {
            window.location.href = "https://racingstars.co.uk/?utm_source=racingleague&utm_medium=referral";
        },


        goToFormat() {
            window.location.href = "https://www.racingleague.uk/stories/competition-format";
        },

        nextSlide() {
            this.$refs.carousel.next();
            this.currentSlideIndex += 1;
        },

        prevSlide() {
            this.$refs.carousel.prev();
            this.currentSlideIndex -= 1;
        },

        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },

        submit() {
            this.form.transform((data) => ({
                ...data,
                referrer: this.referral_code,
                team: this.selectedTeam.value,
            }))
                .post(this.route('register'), {
                    onFinish: () => {
                        this.form.reset('password', 'password_confirmation')
                    },

                    onSuccess: () => {
                        this.$gtm.trackEvent({
                            event: 'New User Registered',
                            category: 'Registrations',
                            action: 'Registration',
                            label: 'User '+this.form.first_name+' '+this.form.last_name+' Registered.',
                            value: 360,
                        })
                    }
                })
        },

        changeSlide() {
            this.signupCarousel = 5;
        }
    },

    computed : {
        isEmailValid() {
            return /^[^@]+@\w+(\.\w+)+\w$/.test(this.form.email);
        },

        doEmailsMatch() {
            return this.form.email === this.confirmEmail;
        },

        isPasswordValid() {
            return this.form.password.length > 8;
        },

        doPasswordsMatch() {
            return this.form.password === this.confirmPassword;
        },

        slideOneComplete() {
            return this.isEmailValid && this.doEmailsMatch && this.form.email.length
        },

        countdownTime() {
            const currentDate = new Date();
            const targetDate = new Date('2023-08-10T17:30:00');
            const timeDifference = targetDate - currentDate;

            return timeDifference > 0 ? timeDifference : 0;
        },

        formatDeadline() {
            const deadlineDate = new Date(Date.now() + this.countdownTime);
            const formattedDeadline = deadlineDate.toISOString().slice(0, 19).replace('T', ' ');

            return formattedDeadline;
        }
    },

    setup(props) {
        const page = usePage()
        const selectedTeam = ref(0)
        const usernameAvailable = ref(1)
        const emailAvailable = ref(1)
        const accountCreated = ref(0)

        const checkUsernamesAvailable = (potUsername) => {
            axios.post(route('api.user.checkUsername'), {
                username: potUsername
            }).then(response => {
                usernameAvailable.value = response.data
            })
        }

        const checkEmailsAvailable = (potEmail) => {
            axios.post(route('api.user.checkEmail'), {
                email: potEmail
            }).then(response => {
                emailAvailable.value = response.data
            })
        }

        onMounted (() => {
            const userInfo = computed(() => usePage().props.value.user).value;
            accountCreated.value = false;

            if (userInfo !== null) {
                accountCreated.value = userInfo;
            }
        })

        /**
         * Formatter function required to format currencies/prices correctly.
         *auth
         * @type {Intl.NumberFormat}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const logout = () => {
            route('logout')
        }

        return {
            formatter,
            page,
            logout,
            selectedTeam,
            checkUsernamesAvailable,
            checkEmailsAvailable,
            usernameAvailable,
            emailAvailable,
            accountCreated
        }

    },
}

</script>
